/* global Lang */

import React, { useState } from 'react';
import styled from 'styled-components';
import Spinner from '../../components/Spinner';
import PlayerProgress from '../../components/PlayerProgress';
import PlayerPlayTime from '../../components/PlayerPlayTime';
import ClickOutside from '../../../common/utilities/ClickOutside';
import Popover from '../../components/Popover';

const HowToText = styled.p`
  white-space: pre-line;
`;

const HowToPopover = styled(Popover)`
  right: 100%;
  left: auto;
  width: 500px;
  max-width: 80vw;
`;

const HowTo = () => {
  const [showing, setShowing] = useState(false);

  return (
    <ClickOutside onClickOutside={() => setShowing(false)}>
      <div className="d-inline-block align-top mr-2 position-relative">
        <button type="button" className="btn btn-info" onClick={() => setShowing(!showing)}>
          {Lang.get('messages.dashboard.header.howToRead')}
        </button>

        <HowToPopover show={showing} position="left">
          <h3>{Lang.get('messages.dashboard.howTo.title')}</h3>
          <HowToText
            dangerouslySetInnerHTML={{
              __html: Lang.get('messages.dashboard.howTo.description'),
            }}
          />
        </HowToPopover>
      </div>
    </ClickOutside>
  );
};

const PlayerDashboardHeader = ({
  className = '',
  loading,
  error,
  user,
  backUrl,
  detailsUrl,
  downloadUrl,
  showHowTo = false,
}) => {
  const {
    progress,
    // eslint-disable-next-line camelcase
    total_time_elapsed,
    name: username,
    code,
  } = user || {};

  if (error) {
    return (
      <p>
        Error:
        {error.response && error.response.data && error.response.data.message}
      </p>
    );
  }

  return (
    <div className={`${className} row mb-4`}>
      <div className="col-md-7 bg-body">
        {backUrl && (
          <div>
            <a href={backUrl} className="btn btn-link text-light p-0">
              <i className="fas fa-angle-left mr-2" />
              {Lang.get('messages.dashboard.header.backToOverview')}
            </a>
          </div>
        )}
        <h2>{`${username} (${code})`}</h2>
        {detailsUrl && (
          <a href={detailsUrl} className="btn btn-link text-light p-0 ml-2">
            {Lang.get('messages.dashboard.header.detailedResults')}
            <i className="fas fa-angle-right ml-2" />
          </a>
        )}
      </div>
      <div className="col-md-5 text-right">
        {showHowTo && <HowTo />}
        <a href={downloadUrl} className="btn btn-success mb-3">
          <i className="fas fa-download mr-2" />
          {Lang.get('messages.dashboard.header.download')}
        </a>
      </div>
      {loading ? (
        <div className="col-12 text-center">
          <Spinner className="spinner-border-sm" />
        </div>
      ) : (
        <>
          <div className="col-6 col-lg-4">
            <PlayerProgress {...progress} />
          </div>
          <div className="col-6 col-lg-3">
            {/* eslint-disable-next-line camelcase */}
            <PlayerPlayTime time={total_time_elapsed} />
          </div>
        </>
      )}
    </div>
  );
};

export default PlayerDashboardHeader;
